/**
 * API helpers for CSM tenant access management.
 * Proxies to /api/admin/csm/tenants (Heimdall) with the given idToken.
 */

import {
    ActiveCSMUserListResponse,
    CSMTenantAccessDTO,
    CSMBulkGrantAccessResponse,
} from '@/shared/types';

export async function listActiveCSMs(idToken: string): Promise<ActiveCSMUserListResponse> {
    const response = await fetch(
        `/api/admin/csm`,
        {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
        }
    );
    if (!response.ok) {
        const err = await response.json().catch(() => ({ detail: response.statusText }));
        throw new Error(err.detail || err.error || response.statusText);
    }
    return response.json();
}

export async function grantCSMTenantAccess(
  idToken: string,
  tenantId: string,
  csmEmail: string
): Promise<CSMTenantAccessDTO> {
  const response = await fetch(
    `/api/admin/csm/tenants/${encodeURIComponent(tenantId)}/csm-access`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
      body: JSON.stringify({ csm_email: csmEmail }),
    }
  );
  if (!response.ok) {
    const err = await response.json().catch(() => ({ detail: response.statusText }));
    throw new Error(err.detail || err.error || response.statusText);
  }
  return response.json();
}

export async function revokeCSMTenantAccess(
    idToken: string,
    tenantId: string,
    csmEmail: string
): Promise<CSMTenantAccessDTO> {
    const response = await fetch(
        `/api/admin/csm/tenants/${encodeURIComponent(tenantId)}/csm-access`,
        {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
            body: JSON.stringify({ csm_email: csmEmail }),
        }
    );
    if (!response.ok) {
        const err = await response.json().catch(() => ({ detail: response.statusText }));
        throw new Error(err.detail || err.error || response.statusText);
    }
    return response.json();
}


export async function grantAllCSMsTenantAccess(
  idToken: string,
  tenantId: string
): Promise<CSMBulkGrantAccessResponse> {
  const response = await fetch(
    `/api/admin/csm/tenants/${encodeURIComponent(tenantId)}/grant-access-bulk`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
    }
  );
  if (!response.ok) {
    const err = await response.json().catch(() => ({ detail: response.statusText }));
    throw new Error(err.detail || err.error || response.statusText);
  }
  return response.json();
}
